"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var react_final_form_1 = require("react-final-form");
var Step2 = function (_a) {
    var setPrevStep = _a.setPrevStep, isSubmitting = _a.isSubmitting;
    var t = (0, next_intl_1.useTranslations)('translation');
    var formState = (0, react_final_form_1.useFormState)();
    var endFullDate = (0, react_1.useMemo)(function () {
        var _a = formState.values.endTime.split(':').map(Number), hours = _a[0], minutes = _a[1];
        var result = (0, date_fns_1.addHours)(new Date(formState.values.endDate).setHours(0, 0, 0, 0), hours);
        result = (0, date_fns_1.addMinutes)(result, minutes);
        return (0, date_fns_1.format)(new Date(result), 'HH:mm, yy-LL-dd');
    }, [formState.values]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t('coolingOff')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t('doYouReallyWantSetCoolingOffLimit')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContent },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentRow },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentTitle }, t('endDateOfTheBlock')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentValue }, endFullDate))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.disclaimer }, t('onceConfirmedCannotEditedUntilExpireCoolingOff'))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", type: "submit", maxWidth: "335px", width: "100%", loading: isSubmitting }, t('confirm')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.backButton, onClick: setPrevStep }, t('cancel')))));
};
exports.default = Step2;
